import type { FC } from 'react';
import { memo, useEffect } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import classNames from 'classnames';
import { ICollectOptionListItem, IlistItem } from '@/utils/ctype';
import { isSafari } from '@/utils/browser';
import style from '../Drag/index.module.less';
import HtmlParser from '../HtmlParser';

export interface DustbinProps {
	accept: string[];
	lastDroppedItem?: { data: ICollectOptionListItem; index: number;} | null;
	onDrop: (item: { data: ICollectOptionListItem | {type: string; index: number; data: ICollectOptionListItem;}; type: string; index: number; }) => void;
  recoverOption: (index: number) => void;
  index: number;
  recoverBlank: () => void;
  data: IlistItem;
  type: string;
  blankClass?: string;
  optionClass?: string;
  blankBoxClass?: string;
  id: string;
  uid: string;
  onFocus: () => void;
}

export const Drop: FC<DustbinProps> = memo(function Drop({
  accept,
  lastDroppedItem,
  onDrop,
  recoverOption,
  recoverBlank,
  index,
  data,
  type,
  blankClass,
  optionClass,
  blankBoxClass,
  id,
  uid,
  onFocus
}) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });

  const [, drag, preview] = useDrag(
    () => ({
      type,
      item: { data: lastDroppedItem, type, index}, // 给出的数据
      end: (item, monitor: any) => {
        // 在上面不做任何动作
        if (isOver) {
          return;
        }
        // 不能放下的时候
        if (!monitor.didDrop()) {
          // 当它放到其他填空的时候去掉自己的选项
          recoverBlank();
          if (lastDroppedItem){
            const {index} = lastDroppedItem;
            recoverOption(index);
          }
          
        }
        // }
      }
    }),
    [lastDroppedItem],
  );

  useEffect(() => {
    if (!isSafari()) {
      preview(new Image(), { captureDraggingState: true }); // 隐藏拖拽dom
    }
  }, []);
  
  return (
    <div ref={drop} data-exam-drop-container data-testid="dustbin" className={classNames(style.blank, blankBoxClass)} id={id}>
      <div data-exam-drop-target data-exam-can-drop={canDrop} data-exam-drop-hover={canDrop && isOver} className={classNames(style.blankBox, canDrop&&isOver ? style.canDrop : '', canDrop ? style.borderColor: '', blankClass)} style={{display: lastDroppedItem ? 'none' : 'block'}}></div>
      {lastDroppedItem && (
        <div data-exam-drag-option data-exam-has-answer="true" className={classNames(style.option, style.dropOption, 'canDrag', optionClass, lastDroppedItem ? style.hasOption: '')} onFocus={onFocus} data-testid="box" ref={drag} tabIndex={0} data-id={`${type}_${data.id}`} data-index={index} data-type={type} data-did={uid} data-disable>
          {/* {lastDroppedItem?.data?.content} */}
          {lastDroppedItem?.data?.title ? <span className={style.letter}><HtmlParser htmlString={lastDroppedItem.data.title}></HtmlParser></span> : null}
          <HtmlParser htmlString={lastDroppedItem?.data?.content}></HtmlParser>
        </div>
      )}
    </div>
  );
});

export default Drop;
